import React, { useState, createContext, useContext, useMemo } from "react";
const PageHighlightElementContext = createContext();

export const usePageHighlight = () => {
    const context = useContext(PageHighlightElementContext)
    if (!context) {
        throw new Error('usePageHighlight must be used within a PageHighlightProvider')
    }
    return context
}

export const PageHighlightProvider = (props) => {
    const [pageHighlight, setPageHighlight] = useState(null);
    const value = useMemo(() => [pageHighlight, setPageHighlight], [pageHighlight]);
    return <PageHighlightElementContext.Provider value={value} {...props}/>;
};